import { ErrorCode } from '@cbsinteractive/avia-js';
import { SizeVO } from 'library/ts/model/vo/SizeVO';
import { PlayerAdapterEvent } from 'library/ts/player/adapter/events/PlayerAdapterEvent';
import { BackgroundImage } from 'library/ts/ui/components/background/BackgroundImage';
import { CSSUnit } from 'library/ts/ui/enums/css/CSSUnit';
import { CSSValue } from 'library/ts/ui/enums/css/CSSValue';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { TagLoggerString } from 'tag/ts/tag/model/enums/TagLoggerString';
import { ErrorMessage, urlToken } from 'tag/ts/tag/model/error/ErrorMessage';
import { errorCodeToken } from 'tag/ts/tag/model/error/ErrorTemplate';
import { createErrorUrl } from 'tag/ts/tag/model/error/ErrorUrl';
import { PlayerType } from 'tag/ts/tag/model/type/PlayerType';
import { TagDomAttribute } from 'tag/ts/tag/model/type/TagDomAttribute';
import { ViewLibrary } from 'tag/ts/tag/view/ViewLibrary';
export class ErrorManager extends AbstractTagClass {
    #overlayContent;
    #fatalError = false;
    #daiFailoverResource;
    #reloadMillstoneWithDaiParamsRemoved = () => {
        this.#daiFailoverResource = this?.tag?.controller?.playerManager?.currentResource;
        const paramsVO = this.utils?.Object?.cloneDeep(this.params);
        this.#daiFailoverResource = this.#removeMillstoneDaiParamsFromSsai(this.#daiFailoverResource, this?.params?.CONTENT?.millstone?.daiParams);
        this.#daiFailoverResource.location.mediaUrl = this.tag?.tagUtilities?.millstoneMetadata(paramsVO).millstone?.streamingUrl;
        paramsVO.CONTENT.resource = this.#daiFailoverResource;
        this.logger?.log('reloadMillstoneWithDaiParamsRemoved:', 'set daiFailoverResource to currentResource, removed DAI params from SSAI params, set mediaUrl to millstone url, loading paramsVO...', '\nparamsVO:', paramsVO, '\nparamsVO.CONTENT.resource.location.mediaUrl:', paramsVO.CONTENT.resource.location.mediaUrl, '\nparamsVO.CONTENT.resource.ad.ssai:', paramsVO.CONTENT.resource.ad.ssai);
        this.#delayedLoad(paramsVO);
    };
    #reloadMillstoneWithSsaiRemoved = () => {
        this.#daiFailoverResource = this?.tag?.controller?.playerManager?.currentResource;
        const paramsVO = this.utils?.Object?.cloneDeep(this.params);
        this.#daiFailoverResource.ad.ssai = null;
        this.#daiFailoverResource.location.mediaUrl = this.tag?.tagUtilities?.millstoneMetadata(paramsVO).millstone?.streamingUrl;
        paramsVO.CONTENT.resource = this.#daiFailoverResource;
        this.logger?.log('reloadMillstoneWithSsaiRemoved:', 'set daiFailoverResource to currentResource, removed SSAI params, set mediaUrl to millstone url, loading paramsVO...', '\nparamsVO:', paramsVO, '\nparamsVO.CONTENT.resource.location.mediaUrl:', paramsVO.CONTENT.resource.location.mediaUrl, '\nparamsVO.CONTENT.resource.ad.ssai:', paramsVO.CONTENT.resource.ad.ssai);
        this.#delayedLoad(paramsVO);
    };
    #reloadApiMetadataWithDaiParamsRemoved = () => {
        this.#daiFailoverResource = this?.tag?.controller?.playerManager?.currentResource;
        const paramsVO = this.utils?.Object?.cloneDeep(this.params);
        this.#daiFailoverResource = this.#removeMillstoneDaiParamsFromSsai(this.#daiFailoverResource, this?.params?.CONTENT?.millstone?.daiParams);
        this.#daiFailoverResource.location.mediaUrl = this?.apiMetadata?.streamingUrl;
        paramsVO.CONTENT.resource = this.#daiFailoverResource;
        this.logger?.log('reloadApiMetadataWithDaiParamsRemoved:', 'set daiFailoverResource to currentResource, removed DAI params from SSAI params, set mediaUrl to ApiMetadata url, loading paramsVO...', '\nparamsVO:', paramsVO, '\nparamsVO.CONTENT.resource.location.mediaUrl:', paramsVO.CONTENT.resource.location.mediaUrl, '\nparamsVO.CONTENT.resource.ad.ssai:', paramsVO.CONTENT.resource.ad.ssai);
        this.#delayedLoad(paramsVO);
    };
    #reloadApiMetadataWithSsaiRemoved = () => {
        this.#daiFailoverResource = this?.tag?.controller?.playerManager?.currentResource;
        const paramsVO = this.utils?.Object?.cloneDeep(this.params);
        this.#daiFailoverResource.ad.ssai = null;
        this.#daiFailoverResource.location.mediaUrl = this?.apiMetadata?.streamingUrl;
        paramsVO.CONTENT.resource = this.#daiFailoverResource;
        this.logger?.log('reloadApiMetadataWithSsaiRemoved:', 'set daiFailoverResource to currentResource, removed SSAI params, set mediaUrl to ApiMetadata url, loading paramsVO...', '\nparamsVO:', paramsVO, '\nparamsVO.CONTENT.resource.location.mediaUrl:', paramsVO.CONTENT.resource.location.mediaUrl, '\nparamsVO.CONTENT.resource.ad.ssai:', paramsVO.CONTENT.resource.ad.ssai);
        this.#delayedLoad(paramsVO);
    };
    daiFailoverOptions = [
        {
            callback: this.#reloadMillstoneWithDaiParamsRemoved,
            attempted: false
        },
        {
            callback: this.#reloadMillstoneWithSsaiRemoved,
            attempted: false
        },
        {
            callback: this.#reloadApiMetadataWithDaiParamsRemoved,
            attempted: false
        },
        {
            callback: this.#reloadApiMetadataWithSsaiRemoved,
            attempted: false
        }
    ];
    constructor(argument) {
        super({
            ...argument,
            name: 'ErrorManager'
        });
        const eventsOfInterest = [
            TagEvent.ON_API_RESET_TAG_REQUEST,
            TagEvent.ON_CREATE_PLAYER_SUCCESS,
            TagEvent.ON_FATAL_ERROR,
            TagEvent.ON_OFFLINE,
            TagEvent.ON_ONLINE,
            TagEvent.ON_PLAYER_EVENT,
            TagEvent.ON_REQUEST_TO_CLEAR_ERROR,
            TagEvent.ON_VIEW_READY
        ];
        if (this?.params?.SKIN?.enabled === true
            &&
                this?.tag?.view?.playerType === PlayerType.CHROMELESS
            &&
                this.params.TAG.errorPanel === true) {
            eventsOfInterest.push(TagEvent.ON_RESIZE);
        }
        this.tagEventsHandler(this.#onTagEvent, eventsOfInterest);
        this.utils.Delay.delay().then(() => this.#setFontSize());
    }
    get overlay() {
        if (this.utils.Type.isElement(this.tag?.params?.TAG?.container)) {
            return this.tag.params.TAG.container.querySelector('[' + TagDomAttribute.OVERLAY + '=' + this.uuid + ']');
        }
        else {
            return undefined;
        }
    }
    get fatalError() {
        return this.#fatalError;
    }
    createErrorMessageByCode(code) {
        this?.logger?.log('createErrorMessageByCode:', 'code', code);
        const errorCopy = this.tag.model.config.tag.ErrorCopy;
        const params = errorCopy.params;
        this?.logger?.log('createErrorMessageByCode:', 'params', params);
        const msgId = params.map[code] || params.map.DEFAULT;
        const msgObj = params.message[msgId];
        const urlObj = params.url[msgObj.urlId];
        let msgCopy = msgObj.copy;
        if (this.utils.Type.isNullOrUndefined(urlObj) === false) {
            const urlMsg = createErrorUrl(urlObj.copy, urlObj.url, urlObj.target, params.style.url.color);
            msgCopy = msgCopy.replace(urlToken, urlMsg);
        }
        if (msgObj.addError === true) {
            let errorTemplate = params.templates?.error;
            errorTemplate = errorTemplate.replace(errorCodeToken, code.toString());
            msgCopy += errorTemplate;
        }
        this?.logger?.log('createErrorMessageByCode:', 'msgCopy', msgCopy);
        return msgCopy;
    }
    #setFontSize = () => {
        if (this.utils.Type.isElement(this.overlay) === false) {
            return;
        }
        const overlayDomRect = this.overlay.getBoundingClientRect();
        const newFontSize = this.utils.Number.roundToDecimal(this.utils.Calc.dynamicValue(new SizeVO(1170, 658), new SizeVO(overlayDomRect.width, overlayDomRect.height), 16, 10, 19), 2);
        this.overlay.style.setProperty('font-size', (newFontSize + CSSUnit.PIXEL), CSSValue.IMPORTANT);
    };
    #showErrorPanelOverlay = (message) => {
        if (this.utils.Type.isElement(this.overlay) === false) {
            return;
        }
        if (this.overlay.innerHTML === message) {
            return;
        }
        this.overlay.innerHTML = '';
        if (this.params.TAG.errorPanel === false) {
            if (this.utils.Type.isFunction(this?.tag?.view?.loadingAnimationManager?.hide)) {
                this.tag.view.loadingAnimationManager.hide();
            }
            return;
        }
        this.#overlayContent = this.utils.DOM.stringToElement(ViewLibrary.ERROR_PANEL);
        this.overlay.appendChild(this.#overlayContent);
        const errorContentEl = this.#overlayContent.querySelector('.smart-tag-error-panel-content');
        errorContentEl.innerHTML = message;
        if (this.utils.URL.valid(this?.tag?.model?.apiMetadata?.thumbnail)) {
            new BackgroundImage(this.#overlayContent.querySelector('.background-image'), this?.tag?.model?.apiMetadata.thumbnail, undefined, undefined, undefined, this.utils, this.runtimeVO);
        }
        this.utils.Delay.delay(100)
            .then(() => {
            if (!this.utils.Type.isEmpty(this?.overlay?.style)) {
                this.overlay.style.setProperty('top', '0', CSSValue.IMPORTANT);
            }
        })
            .then(() => this.utils.Delay.delay())
            .then(() => {
            if (this.utils.Type.isElement(this.#overlayContent)) {
                this.#overlayContent.style.setProperty('opacity', '1', CSSValue.IMPORTANT);
            }
            if (this.utils.Type.isElement(errorContentEl)) {
                errorContentEl.setAttribute('role', 'alert');
            }
        });
    };
    #hideErrorPanelOverlay = () => {
        if (this.utils.Type.isElement(this.overlay) === false) {
            return;
        }
        this.overlay.innerHTML = '';
        this.#overlayContent = undefined;
        this.overlay.style.setProperty('top', '-10000px', CSSValue.IMPORTANT);
    };
    #dispatchFatalErrorEvent = (playerAdapterEvent) => {
        const eventDetail = playerAdapterEvent?.detail?.error;
        this?.logger?.warn(TagLoggerString.ON_PLAYER_EVENT, playerAdapterEvent?.type, playerAdapterEvent, eventDetail?.message);
        this.dispatchTagEvent(this.tag.getTagEventVO(TagEvent.ON_FATAL_ERROR, this.tag, {
            fatalError: {
                code: eventDetail?.code,
                msg: {
                    original: eventDetail?.message,
                    custom: this.createErrorMessageByCode(eventDetail?.code)
                },
                error: playerAdapterEvent
            }
        }));
    };
    #daiFailoverRequired = () => {
        if (this.utils?.Type.isEmpty(this?.params?.SYSTEM?.embedType) ||
            this.utils?.Type?.isEmpty(this?.params?.CONTENT?.daiFailover) ||
            !this.utils.Type.isArray(this?.params?.CONTENT?.daiFailover)) {
            this?.logger?.log('daiFailoverRequired:', 'required params are invalid... returning false', '\nparams.SYSTEM:', this?.params?.SYSTEM, '\nparams.CONTENT.daiFailover:', this?.params?.CONTENT?.daiFailover);
            return false;
        }
        return this?.params?.CONTENT?.daiFailover?.includes(this?.params?.SYSTEM?.embedType);
    };
    #delayedLoad = (paramsVO, delay = 50) => {
        this.logger?.log('delayedLoad:', 'calling VideoAPI.load(paramsVO) after delay...', '\ndelay:', delay, '\nparamsVO:', paramsVO, '\nparamsVO.CONTENT.resource:', paramsVO?.CONTENT?.resource, '\nresource.location.mediaUrl:', paramsVO?.CONTENT?.resource?.location?.mediaUrl, '\nresource.ad.ssai:', JSON.stringify(paramsVO?.CONTENT?.resource?.ad?.ssai, null, 4));
        this.utils?.Delay?.delay(delay).then(() => {
            this.tag?.API?.VIDEO?.load(paramsVO)
                .then((res) => {
                this.logger?.log('delayedLoad:', 'VideoAPI.load(paramsVO) success', 'res:', res);
            })
                .catch((error) => {
                this.logger?.warn('delayedLoad:', 'VideoAPI.load(paramsVO) ERROR', 'error:', error);
            });
        });
    };
    #getNextDaiFailoverOption = () => {
        return this.daiFailoverOptions.find((failoverOption) => {
            if (failoverOption.attempted === false) {
                return failoverOption;
            }
            return undefined;
        });
    };
    #removeMillstoneDaiParamsFromSsai = (resource, daiParams) => {
        if (this.utils?.Type?.isObject(daiParams) &&
            !this.utils?.Type?.isEmpty(daiParams)) {
            Object.keys(daiParams).forEach((key) => {
                const value = resource?.ad?.ssai?.adParameters?.[key];
                delete resource?.ad?.ssai?.adParameters?.[key];
                this.logger?.log('removeMillstoneDaiParamsFromSsai:', '\nremoved millstone DAI param from SSAI adParameters', '\nkey:', key, '\nvalue:', value, '\nresource.ad.ssai.adParameters:', resource?.ad?.ssai?.adParameters);
            });
        }
        return resource;
    };
    #executeDaiFailoverOption = (option, playerAdapterEvent) => {
        this.logger?.log('executeDaiFailoverOption:', 'executing DAI failover option...', '\noption:', option, '\nevent:', playerAdapterEvent);
        try {
            option.attempted = true;
            option?.callback();
        }
        catch (error) {
            this.logger?.warn('executeDaiFailoverOption:', 'error executing DAI failover option', '\noption:', option, '\nerror:', error);
        }
    };
    #handleDaiError = (playerAdapterEvent) => {
        const eventDetail = playerAdapterEvent?.detail?.error;
        this?.logger?.log('handleDaiError:', TagLoggerString.ON_PLAYER_EVENT, playerAdapterEvent?.type, 'fatal:', eventDetail?.fatal, 'ERROR CODE:', eventDetail?.code, 'eventDetail:', eventDetail);
        if (this.#daiFailoverRequired() === false) {
            this?.logger?.log('handleDaiError:', 'DAI Failover is not required... dispatching Fatal Error');
            this.#dispatchFatalErrorEvent(playerAdapterEvent);
            return;
        }
        const unattemptedFallbackOption = this.#getNextDaiFailoverOption();
        if (this.utils?.Type?.isEmpty(unattemptedFallbackOption)) {
            this?.logger?.log('handleDaiError:', 'all fallback options attempted... dispatching Fatal Error');
            this.#dispatchFatalErrorEvent(playerAdapterEvent);
            return;
        }
        this.#executeDaiFailoverOption(unattemptedFallbackOption, playerAdapterEvent);
    };
    #onPlayerEvent = (data) => {
        const playerAdapterEvent = data?.playerAdapterEvent;
        if (this.utils.Type.isEmpty(playerAdapterEvent) || playerAdapterEvent?.detail?.error?.fatal !== true) {
            return;
        }
        switch (playerAdapterEvent?.type) {
            case PlayerAdapterEvent.ERROR:
                const eventDetail = playerAdapterEvent?.detail?.error;
                switch (eventDetail?.code) {
                    case ErrorCode.DAI_DATA_ERROR:
                    case ErrorCode.DAI_NETWORK_ERROR:
                    case ErrorCode.DAI_SDK_MISSING:
                        this.#handleDaiError(playerAdapterEvent);
                        break;
                    default:
                        this.#dispatchFatalErrorEvent(playerAdapterEvent);
                }
        }
    };
    #onTagEvent = (event) => {
        switch (event?.type) {
            case TagEvent.ON_VIEW_READY:
                this.removeTagEventsHandler(this.#onTagEvent, this?.tag?.eventDispatcher, [event?.type]).then();
                this.#setFontSize();
                break;
            case TagEvent.ON_RESIZE:
                this.#setFontSize();
                break;
            case TagEvent.ON_ONLINE:
                this.#hideErrorPanelOverlay();
                break;
            case TagEvent.ON_OFFLINE:
                if (this.#fatalError === false)
                    this.#showErrorPanelOverlay(ErrorMessage['OFFLINE'].copy);
                break;
            case TagEvent.ON_FATAL_ERROR:
                this.#fatalError = true;
                const msg = event?.data?.fatalError?.msg;
                let msgToShow = msg?.custom;
                if (this.utils.Type.isString(msgToShow) === false)
                    msgToShow = msg?.original;
                if (this.utils.Type.isString(msgToShow)) {
                    msgToShow = msgToShow.replace(errorCodeToken, event?.data?.fatalError?.code);
                    this.#showErrorPanelOverlay(msgToShow);
                }
                this?.logger?.warn('onFatalError:', event?.data?.fatalError, '\nMessage:', msg);
                break;
            case TagEvent.ON_CREATE_PLAYER_SUCCESS:
                this.utils.Delay.delay().then(() => this.#hideErrorPanelOverlay());
                break;
            case TagEvent.ON_REQUEST_TO_CLEAR_ERROR:
            case TagEvent.ON_API_RESET_TAG_REQUEST:
                this?.logger?.log(TagLoggerString.ON_TAG_EVENT, event?.type, event);
                this.#fatalError = false;
                this.#hideErrorPanelOverlay();
                break;
            case TagEvent.ON_PLAYER_EVENT:
                this.#onPlayerEvent(event?.data);
                break;
        }
    };
}
